import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { LotWithJobsDto } from "../models/LotDto";
import { environment } from "../../../core/config/environment";
import { Lot, db } from "../../../core/database/db";

@Injectable({
  providedIn: "root"
})
export class LotService {

  private readonly url = `${environment.backend.apiBaseURL}/api/lot`;

  constructor(private http: HttpClient) { }

  getLotsWithJobs(divisionId: number): Observable<LotWithJobsDto[]> {
    const url = `${this.url}/LotsWithJobs/${divisionId}`;

    return this.http.get<LotWithJobsDto[]>(url);
  }

  async getLotById(lotId: number): Promise<Lot | undefined> {
    return await db.lot.get(lotId);
  }

  async getLotsByIds(lotIds: number[]): Promise<Lot[]> {
    if (lotIds.length === 0) {
      return [];
    }

    return await db.lot.where("id").anyOf(lotIds)
      .toArray();
  }
}